module.exports = __webpack_public_path__ + "img/1531277335.25056e1a.jpg";